import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const activateContract = (id,items,amort)=> {
	return axios.post(API + "contracts/contract-activate/"+id+"/" ,{items,amort},{ headers: authHeader() })}

const ACtivateContractService = {
    activateContract,
  };
  export default ACtivateContractService;